// // assets/product-custom-property.js
// import { Component } from '@theme/component';

// /**
//  * @typedef {object} ProductCustomPropertyRefs
//  * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
//  * @property {HTMLElement} characterCount - The character count element.
//  */

// /**
//  * A custom element that manages product custom properties
//  * @extends Component<ProductCustomPropertyRefs>
//  */
// class ProductCustomProperty extends Component {
//   handleInput() {
//     this.#updateCharacterCount();
//   }

//   #updateCharacterCount() {
//     const { characterCount, textInput } = this.refs;
//     const currentLength = textInput.value.length;
//     const maxLength = textInput.maxLength;

//     const template = characterCount.getAttribute('data-template');
//     if (!template) return;

//     const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

//     characterCount.textContent = updatedText;
//   }
// }

// customElements.define('product-custom-property-component', ProductCustomProperty);


// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput
 * @property {HTMLElement} characterCount
 * @property {HTMLElement} heading
 * @property {HTMLElement} field
 */

class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback?.();

    this.refs.heading?.addEventListener('click', this.handleToggle.bind(this));

    // Default hidden
    if (this.refs.field) {
      this.refs.field.style.display = 'none';
    }
  }

  handleInput() {
    this.#updateCharacterCount();
  }

  handleToggle() {
    const { field } = this.refs;

    if (!field) return;

    if (field.style.display === 'none') {
      field.style.display = 'block';
    } else {
      field.style.display = 'none';
    }
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;

    if (!characterCount || !textInput) return;

    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');

    if (!template) return;

    const updatedText = template
      .replace('[current]', currentLength.toString())
      .replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define(
  'product-custom-property-component',
  ProductCustomProperty
);